export const mockHistoryDetail = {
  "page": 1,
  "total_pages": 1,
  "interactions": [
    {
      "created_at": "2026-02-02T10:05:02.687761Z",
      "request": {
        "message": {
          "text": "variazioni catastali",
          "type": "text"
        },
        "prefilledVariables": {
          "upn": "admin@example.com",
          "chatId": "1770026692300",
          "userId": "icWrS9DMPO3gzUWsn2Q0QiN5ulIfuS2TYsVHAfcZqNJXQnMVZiBgWOYa11111111"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "typebot": {
          "id": "k1ok419sh8xio6d7mg4ih61s",
          "theme": {},
          "version": "6",
          "settings": {},
          "publishedAt": "2025-12-24T16:23:46.794Z"
        },
        "messages": [
          {
            "id": "txsswo9yz1p6nulork9sta9g",
            "type": "text",
            "content": {
              "type": "markdown",
              "markdown": "Per aiutarti al meglio, potresti indicare se sei interessato a ricevere informazioni su Varianti, IRU Management, Rendicontazione Tecnica AG oppure sulla Modulistica di uno di questi argomenti?"
            }
          }
        ],
        "resultId": "jhr8pkvazqwl1p3ypkoqkpz6",
        "sessionId": "q6gbi60cu0mpjwysqses5yg4",
        "clientSideActions": [
          {
            "type": "setVariable",
            "setVariable": {
              "scriptToExecute": {
                "args": [
                  {
                    "id": "vp7th19waxx58xn2bzxyuigwk",
                    "value": "{\u0022collect_feedback\u0022:false}"
                  }
                ],
                "isCode": true,
                "content": "vp7th19waxx58xn2bzxyuigwk"
              }
            },
            "lastBubbleBlockId": "txsswo9yz1p6nulork9sta9g",
            "expectsDedicatedReply": true
          }
        ]
      }
    },
    {
      "created_at": "2026-02-02T10:05:02.925286Z",
      "request": {
        "message": {
          "text": "next",
          "type": "text"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "input": {
          "id": "bk61tm0mm2x9lb5qw32zh4g8",
          "type": "text input",
          "options": {
            "variableId": "nalq9xp748xgkcfca6kyhjae"
          },
          "outgoingEdgeId": "rb464f0wkyid9odec6bms9o5",
          "prefilledValue": "variazioni catastali"
        },
        "messages": [],
        "clientSideActions": []
      }
    },
    {
      "created_at": "2026-02-02T10:05:27.891955Z",
      "request": {
        "message": {
          "text": "iru management",
          "type": "text"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "messages": [
          {
            "id": "txsswo9yz1p6nulork9sta9g",
            "type": "text",
            "content": {
              "type": "markdown",
              "markdown": "Sulla base delle informazioni disponibili, non emergono dettagli specifici relativi alle **variazioni catastali** all\u0027interno dei processi di **Rendicontazione Tecnica AG**, **Varianti**, **IRU Management**, **Processo Penali**, **Norme di Progettazione** o **Delivery**. Non sono presenti istruzioni operative dettagliate per la gestione concreta delle **variazioni catastali** nei contesti di **e-distribuzione** o **Open Fiber**.\n\nGeneralmente, le **modifiche catastali** richieste per la gestione di infrastrutture o progetti di rete, come l\u2019aggiornamento della propriet\u00e0 dei terreni coinvolti in una variante di progetto, vengono effettuate tramite richieste agli enti comunali competenti. Queste procedure sono spesso necessarie per garantire la corretta documentazione e la validazione dei lavori eseguiti.\n\nSe necessiti di informazioni pi\u00f9 dettagliate, come ad esempio le procedure da seguire, i documenti da inviare, le tempistiche di gestione o gli impatti sulle varianti di progetto, ti suggerisco di specificare ulteriormente la richiesta. In questo modo potr\u00f2 offrirti un supporto pi\u00f9 mirato.\n\nResto a disposizione per eventuali ulteriori chiarimenti!"
            }
          }
        ],
        "clientSideActions": [
          {
            "type": "setVariable",
            "setVariable": {
              "scriptToExecute": {
                "args": [
                  {
                    "id": "vp7th19waxx58xn2bzxyuigwk",
                    "value": "{\u0022references\u0022:[{\u0022title\u0022:\u0022Condizioni_generali_di_Accesso_all_Infrastruttura_elettrica\u0022,\u0022drupal_id\u0022:\u0022276\u0022,\u0022contents\u0022:\u0022\u0022,\u0022score\u0022:0.3618668844980752,\u0022type\u0022:\u0022\u0022},{\u0022title\u0022:\u0022Norme_Procedure_tecniche_di_accesso_IVA_ISO\u0022,\u0022drupal_id\u0022:\u0022275\u0022,\u0022contents\u0022:\u0022\u0022,\u0022score\u0022:0.35336384918525227,\u0022type\u0022:\u0022\u0022}],\u0022collect_feedback\u0022:true}"
                  }
                ],
                "isCode": true,
                "content": "vp7th19waxx58xn2bzxyuigwk"
              }
            },
            "lastBubbleBlockId": "txsswo9yz1p6nulork9sta9g",
            "expectsDedicatedReply": true
          }
        ]
      }
    },
    {
      "created_at": "2026-02-02T10:05:28.173637Z",
      "request": {
        "message": {
          "text": "iru management",
          "type": "text"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "messages": [
          {
            "id": "galjz0pjit65fidz9pvjeory",
            "type": "text",
            "content": {
              "type": "markdown",
              "markdown": "Fornisci una valutazione da 1 (Basso) a 5 (Alto)"
            }
          }
        ],
        "clientSideActions": [
          {
            "type": "setVariable",
            "setVariable": {
              "scriptToExecute": {
                "args": [
                  {
                    "id": "icbgl3pvs2ive1ndfmga4gbv",
                    "value": "{\u0022choices\u0022:[{\u0022label\u0022:\u00221\u0022,\u0022value\u0022:\u00221\u0022,\u0022type\u0022:\u0022star\u0022},{\u0022label\u0022:\u00222\u0022,\u0022value\u0022:\u00222\u0022,\u0022type\u0022:\u0022star\u0022},{\u0022label\u0022:\u00223\u0022,\u0022value\u0022:\u00223\u0022,\u0022type\u0022:\u0022star\u0022},{\u0022label\u0022:\u00224\u0022,\u0022value\u0022:\u00224\u0022,\u0022type\u0022:\u0022star\u0022},{\u0022label\u0022:\u00225\u0022,\u0022value\u0022:\u00225\u0022,\u0022type\u0022:\u0022star\u0022},{\u0022label\u0022:\u0022Annulla\u0022,\u0022value\u0022:\u0022Annulla\u0022,\u0022type\u0022:\u0022text\u0022}]}"
                  }
                ],
                "isCode": false,
                "content": "icbgl3pvs2ive1ndfmga4gbv"
              }
            },
            "lastBubbleBlockId": "galjz0pjit65fidz9pvjeory",
            "expectsDedicatedReply": true
          }
        ]
      }
    },
    {
      "created_at": "2026-02-02T10:05:28.401144Z",
      "request": {
        "message": {
          "text": "next",
          "type": "text"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "input": {
          "id": "jzdtywa6kmsh3gtgnlfbjt0v",
          "type": "text input",
          "options": {
            "variableId": "wvx6xrlwxikos7n7reilog6c"
          }
        },
        "messages": [],
        "clientSideActions": []
      }
    },
    {
      "created_at": "2026-02-02T10:05:38.663223Z",
      "request": {
        "message": {
          "text": "5",
          "type": "text"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "messages": [],
        "clientSideActions": []
      }
    },
    {
      "created_at": "2026-02-02T10:05:59.374629Z",
      "request": {
        "message": {
          "text": "modulistica varianti",
          "type": "text"
        },
        "prefilledVariables": {
          "upn": "admin@example.com",
          "chatId": "1770026692300",
          "userId": "icWrS9DMPO3gzUWsn2Q0QiN5ulIfuS2TYsVHAfcZqNJXQnMVZiBgWOYa11111111"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "typebot": {
          "id": "k1ok419sh8xio6d7mg4ih61s",
          "theme": {},
          "version": "6",
          "settings": {},
          "publishedAt": "2025-12-24T16:23:46.794Z"
        },
        "messages": [
          {
            "id": "txsswo9yz1p6nulork9sta9g",
            "type": "text",
            "content": {
              "type": "markdown",
              "markdown": "Il documento richiesto non \u00e8 stato Trovato. Puoi provare ad essere pi\u00f9 specifico nella tua richiesta o aggiungere dettagli"
            }
          }
        ],
        "resultId": "jeinjw5syrjl01a0ucmhcsg9",
        "sessionId": "zf5kvkqh2hbqnm2zloxukd94",
        "clientSideActions": [
          {
            "type": "setVariable",
            "setVariable": {
              "scriptToExecute": {
                "args": [
                  {
                    "id": "vp7th19waxx58xn2bzxyuigwk",
                    "value": "{\u0022references\u0022:[],\u0022collect_feedback\u0022:false}"
                  }
                ],
                "isCode": true,
                "content": "vp7th19waxx58xn2bzxyuigwk"
              }
            },
            "lastBubbleBlockId": "txsswo9yz1p6nulork9sta9g",
            "expectsDedicatedReply": true
          }
        ]
      }
    },
    {
      "created_at": "2026-02-02T10:05:59.585943Z",
      "request": {
        "message": {
          "text": "next",
          "type": "text"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "input": {
          "id": "bk61tm0mm2x9lb5qw32zh4g8",
          "type": "text input",
          "options": {
            "variableId": "nalq9xp748xgkcfca6kyhjae"
          },
          "outgoingEdgeId": "rb464f0wkyid9odec6bms9o5",
          "prefilledValue": "modulistica varianti"
        },
        "messages": [],
        "clientSideActions": []
      }
    },
    {
      "created_at": "2026-02-02T10:06:30.284767Z",
      "request": {
        "message": {
          "text": "modulistica rendicontazione",
          "type": "text"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "messages": [
          {
            "id": "txsswo9yz1p6nulork9sta9g",
            "type": "text",
            "content": {
              "type": "markdown",
              "markdown": "Per la **modulistica relativa alla rendicontazione** viene adottato un **template\/form di raccolta dati strutturati**, progettato per coprire in modo completo tutte le fasi e le aree tematiche di ciascun progetto. Questo modulo, descritto dettagliatamente nel documento principale di riferimento, \u00e8 organizzato in diverse sezioni fondamentali.\n\nEcco la struttura del modulo:\n\n* **Anagrafica**: in questa sezione vengono raccolti i dati identificativi relativi al lotto o progetto, come Regione, Provincia, Comune e vari codici di riferimento.\n* **Contratto \/ Ordine di Acquisto (OdA)**: qui si inseriscono i dettagli legati ai contratti, agli ordini, ai fornitori e ai link diretti ai documenti pertinenti.\n* **Entrata Merci**: sono riportate le informazioni sui documenti di ricezione merci, con indicazione di quantit\u00e0, costi e importi.\n* **Fatturazione**: vengono elencati i dati relativi alle fatture, ai fornitori, agli importi e agli eventuali documenti allegati.\n* **Pagamenti**: questa sezione include dettagli sui bonifici, sugli estratti conto, sulle quietanze e contiene i link ai corrispondenti documenti.\n* **Note**: spazio dedicato alle annotazioni tecniche e amministrativo-contabili.\n* **Verifiche**: riservata esclusivamente a **INFRATEL**, serve per la validazione tecnica e amministrativa. Qui si trovano campi per integrazioni, importi riconosciuti o decurtati, quote di finanziamento o cofinanziamento.\n\nLa compilazione di ciascuna sezione richiede l\u2019inserimento di dati specifici e, spesso, il collegamento a documenti digitali come contratti, fatture ed estratti conto. Il modulo viene progressivamente aggiornato in funzione dello stato di avanzamento del progetto.\n\nLe funzioni aziendali coinvolte nell\u2019utilizzo della modulistica sono molteplici: **Network**, **Concessione**, **AFC** e **INFRATEL**. Ognuna \u00e8 responsabile per la compilazione di sezioni e dati di propria competenza.\n\nLa finalit\u00e0 principale di questa modulistica \u00e8 garantire la **rendicontazione** e il **controllo amministrativo, tecnico e finanziario** dei progetti e dei lotti, risultando indispensabile per la richiesta di erogazione fondi o per la rendicontazione verso enti come **INFRATEL**.\n\nSe desideri consultare il **fac-simile del modulo**, approfondire i singoli campi da compilare oppure ricevere indicazioni operative su dove reperire il template, ti invito a visionare il file tramite il collegamento in basso."
            }
          }
        ],
        "clientSideActions": [
          {
            "type": "setVariable",
            "setVariable": {
              "scriptToExecute": {
                "args": [
                  {
                    "id": "vp7th19waxx58xn2bzxyuigwk",
                    "value": "{\u0022references\u0022:[{\u0022title\u0022:\u0022TEC.PLAN.AL.003- Track_ rendicontazione_tabella_responsabilit\u00e0\u0022,\u0022drupal_id\u0022:\u0022499\u0022,\u0022contents\u0022:\u0022\u0022,\u0022score\u0022:0.2790808075372397,\u0022type\u0022:\u0022template\u0022}],\u0022collect_feedback\u0022:true}"
                  }
                ],
                "isCode": true,
                "content": "vp7th19waxx58xn2bzxyuigwk"
              }
            },
            "lastBubbleBlockId": "txsswo9yz1p6nulork9sta9g",
            "expectsDedicatedReply": true
          }
        ]
      }
    },
    {
      "created_at": "2026-02-02T10:06:30.487306Z",
      "request": {
        "message": {
          "text": "modulistica rendicontazione",
          "type": "text"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "messages": [
          {
            "id": "galjz0pjit65fidz9pvjeory",
            "type": "text",
            "content": {
              "type": "markdown",
              "markdown": "Fornisci una valutazione da 1 (Basso) a 5 (Alto)"
            }
          }
        ],
        "clientSideActions": [
          {
            "type": "setVariable",
            "setVariable": {
              "scriptToExecute": {
                "args": [
                  {
                    "id": "icbgl3pvs2ive1ndfmga4gbv",
                    "value": "{\u0022choices\u0022:[{\u0022label\u0022:\u00221\u0022,\u0022value\u0022:\u00221\u0022,\u0022type\u0022:\u0022star\u0022},{\u0022label\u0022:\u00222\u0022,\u0022value\u0022:\u00222\u0022,\u0022type\u0022:\u0022star\u0022},{\u0022label\u0022:\u00223\u0022,\u0022value\u0022:\u00223\u0022,\u0022type\u0022:\u0022star\u0022},{\u0022label\u0022:\u00224\u0022,\u0022value\u0022:\u00224\u0022,\u0022type\u0022:\u0022star\u0022},{\u0022label\u0022:\u00225\u0022,\u0022value\u0022:\u00225\u0022,\u0022type\u0022:\u0022star\u0022},{\u0022label\u0022:\u0022Annulla\u0022,\u0022value\u0022:\u0022Annulla\u0022,\u0022type\u0022:\u0022text\u0022}]}"
                  }
                ],
                "isCode": false,
                "content": "icbgl3pvs2ive1ndfmga4gbv"
              }
            },
            "lastBubbleBlockId": "galjz0pjit65fidz9pvjeory",
            "expectsDedicatedReply": true
          }
        ]
      }
    },
    {
      "created_at": "2026-02-02T10:06:30.802373Z",
      "request": {
        "message": {
          "text": "next",
          "type": "text"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "input": {
          "id": "jzdtywa6kmsh3gtgnlfbjt0v",
          "type": "text input",
          "options": {
            "variableId": "wvx6xrlwxikos7n7reilog6c"
          }
        },
        "messages": [],
        "clientSideActions": []
      }
    },
    {
      "created_at": "2026-02-02T10:06:41.232554Z",
      "request": {
        "message": {
          "text": "5",
          "type": "text"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "messages": [],
        "clientSideActions": []
      }
    },
    {
      "created_at": "2026-02-02T10:07:04.047530Z",
      "request": {
        "message": {
          "text": "ciao",
          "type": "text"
        },
        "prefilledVariables": {
          "upn": "admin@example.com",
          "chatId": "1770026692300",
          "userId": "icWrS9DMPO3gzUWsn2Q0QiN5ulIfuS2TYsVHAfcZqNJXQnMVZiBgWOYa11111111"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "typebot": {
          "id": "k1ok419sh8xio6d7mg4ih61s",
          "theme": {},
          "version": "6",
          "settings": {},
          "publishedAt": "2025-12-24T16:23:46.794Z"
        },
        "messages": [
          {
            "id": "txsswo9yz1p6nulork9sta9g",
            "type": "text",
            "content": {
              "type": "markdown",
              "markdown": "Ciao! Sono Mr Brain. Posso chiarirti dubbi su: Rendicontazione Tecnica AG, Varianti, IRU Management, Processo Penali, Norme di Progettazione, Delivery. Come posso aiutarti oggi?"
            }
          }
        ],
        "resultId": "mryysygpbn9vwyk58fwruaq2",
        "sessionId": "ivzgoerqo3y6ntone5pljeyn",
        "clientSideActions": [
          {
            "type": "setVariable",
            "setVariable": {
              "scriptToExecute": {
                "args": [
                  {
                    "id": "vp7th19waxx58xn2bzxyuigwk",
                    "value": "{\u0022references\u0022:[],\u0022collect_feedback\u0022:false}"
                  }
                ],
                "isCode": true,
                "content": "vp7th19waxx58xn2bzxyuigwk"
              }
            },
            "lastBubbleBlockId": "txsswo9yz1p6nulork9sta9g",
            "expectsDedicatedReply": true
          }
        ]
      }
    },
    {
      "created_at": "2026-02-02T10:07:04.272135Z",
      "request": {
        "message": {
          "text": "next",
          "type": "text"
        },
        "textBubbleContentFormat": "markdown"
      },
      "response": {
        "logs": [],
        "input": {
          "id": "bk61tm0mm2x9lb5qw32zh4g8",
          "type": "text input",
          "options": {
            "variableId": "nalq9xp748xgkcfca6kyhjae"
          },
          "outgoingEdgeId": "rb464f0wkyid9odec6bms9o5",
          "prefilledValue": "ciao"
        },
        "messages": [],
        "clientSideActions": []
      }
    }
  ]
}

export const mockedChat = {
      "messages": [
          {
              "id": "txsswo9yz1p6nulork9sta9g",
              "type": "text",
              "content": {
                  "type": "markdown",
                  "markdown": "Per caricare il pacchetto As-Built, segui questi passaggi:\n\n1. **Accesso al sistema**: L’utente “Service di progettazione” può effettuare l’accesso al sistema NeST tramite il link fornito. Una volta inseriti username e password correttamente, clicca su ‘Accedi’.2. **Accesso al Tab “Documenti As-Built”**: Dopo aver effettuato l’accesso, inserisci nella barra di ricerca il nome del Comune su cui il Service di Progettazione deve produrre/caricare i documenti. Apparirà una serie di suggerimenti. Passa con il mouse sul comune interessato e poi sulla lista relazionata ‘Projects’. Saranno mostrati tutti i Progetti dipendenti con l’oggetto selezionato.3. **Selezione del Progetto**: Seleziona il progetto relativo alla componente “Municipality”.4. **Avvio dei controlli**: Accedi al tab “Documenti As-Built FTTH” per avviare i controlli. Nella lista dei Placeholder As-Built, seleziona i documenti su cui effettuare i controlli di I livello (su singolo documento) o di II livello (cross documenti). Dopo aver spuntato i documenti di interesse, avvia i controlli selezionando il pulsante “Avvio Controlli”.5. **Esito dei controlli**: L’esito sarà visualizzabile tramite il pulsante “Esito Controlli”. Nella schermata di “Esito Controlli” sarà possibile visualizzare il numero di controlli con esito “OK” e “KO”. È possibile scaricare un report in formato Excel con tutti i controlli effettuati.6. **Produzione e caricamento documenti**: Una volta definita la tipologia di pacchetto (Parziale o Totale), l’Utente Service di Progettazione può procedere con la produzione e il caricamento dei documenti, come da indicazioni riportate nel documento di riferimento.\nSe hai bisogno di ulteriori dettagli, fammi sapere!"
              }
          }
      ],
      "clientSideActions": [
          {
              "type": "setVariable",
              "setVariable": {
                  "scriptToExecute": {
                      "content": "vu22m36yq4n9tnc06g6nk6p2l",
                      "isCode": true,
                      "args": [
                          {
                              "id": "vu22m36yq4n9tnc06g6nk6p2l",
                              "value": "{\"references\":[{\"title\":\"Procedura operativa_Processo As-Built\",\"drupal_id\":\"18\",\"contents\":[\"Per accedereallasezione dedicata al pacchettoAs-Builtoccorrerà andare sul progettorelativo alla componente“Municipality” (Step 3).\\n![image](http://eraamsnppya01.aws.openfiber.it:30101/files/6d46ef7e-0054-4ab3-90db-6137e5e8f779/image-preview?timestamp=1751968451&nonce=ad0cdadb9ffad26ffa68624abdafde4f&sign=K0FWkr4OZZ8mSfw7Ks0Y23a0gcm3MZIsrvjPuOKAG2w=)\\nGli Utenti in base alle competenze e responsabilità sul progetto hanno in carico diverse funzionalità suNeSTcome spiegato nel paragrafo“Processo di Controllo e Validazione PacchettoAs-Built”.\\nSceltaTipologiadiRendicontazione–Utente:Service di Progettazione\\nGli step approvativi del pacchettoAs-Builtpossono essere visualizzatinel tab Schedule(Step 4):\\n![image](http://eraamsnppya01.aws.openfiber.it:30101/files/da61bf29-a77e-414a-b54b-5ad9a7294425/image-preview?timestamp=1751968451&nonce=555b2ffecf8b0989346c887cd2872dab&sign=nOU_vdwC95u_o10IEW6vbzlwBS9H47DNnScs4VAwoi4=)\\nIl Servicedi Progettazionepuò selezionaretramitepicklist(Step 5), se si tratta di unAs-BuiltParziale oppure no.\\n![image](http://eraamsnppya01.aws.openfiber.it:30101/files/fd362ec9-3171-4624-a1b9-5cd014bc89a4/image-preview?timestamp=1751968451&nonce=2db85e5fffc5245513358a167f9802f8&sign=iaof_im36YFJYlkKOF8_7ekokXdCxGyV0XR_UTUtTjw=)\\nNel caso di Rendicontazione Parziale, l’utente Service di Progettazione seleziona il campo\\\"SI\\\", la sezione sarà mostratanellamilestone \\\"As-BuiltParziale\\\".I documenti inseriti in caso diAs-BuiltParzialesono i seguenti:\\nCOMPUTO METRICO\\nSHAPEParziale\\nVERBALI IRU\\nASSEVERAZIONE PERMESSI\\nGIUSTIFICATIVO RIPRISTINI\\nSPEED TEST\\n![image](http://eraamsnppya01.aws.openfiber.it:30101/files/b681b363-8f69-437f-8a12-a28a5848c32e/image-preview?timestamp=1751968451&nonce=e0b2d01f6f6aae481b48c35197590141&sign=7Jz-Lvl4PHKccI1ALBg-4fJh4aWNkftUyQ72FeL7M38=)\\nNel casodiRendicontazione Totale, l’utente Service di Progettazione seleziona il campo\\\"NO\\\"oppure il campo vuoto, la sezione sarà mostratanellamilestone \\\"AsBuiltTotale”. I documenti inseriti in caso diAs-BuiltTotale sono i seguenti:\\nCRE\\nCOMPUTO METRICO\\nRET\\nSHAPE\\nMISURE OTTICHE\\nSINOTTICO\\nVERBALI IRU\\nASSEVERAZIONE PERMESSI\\nRELAZIONI CIVICI NON COLLEGABILI\\nFOTO CIVICI NON COLLEGABILI\\nFOTO ROE\\nGIUSTIFICATIVO RIPRISTINI\\nI documenti relativi ai comuni sede POP sono i seguenti:\\nRET Apparati\\nRET PCN\\nCartella Foto POP/Apparati\\nAsseverazione Permessi PCN\\nCartella documenti IRU POP\\nLa sezione \\\"As-BuiltTotale\\\" sarà visualizzata come sezione finale.\\nUna volta definita latipologiadi pacchetto, Parziale oTotale,l’UtenteService di Progettazione, cliccando sul tab “5.1 Produzione Pacchetto AB Totale FTTH” può procedere con la produzione ecaricamento documenti, come da indicazioni riportate nel documento di “”.A seguire,NeSTinvia una notificatramite mailal Service di Controllo che dovrà procedere con l’analisi del pacchettoAs-Built,contestualmenteall’attualizzazione del tab “5.2 Validazione Pacchetto AB Tot\"],\"score\":0.46229767327441385},{\"title\":\"Nest Manuale Utente v1.7\",\"drupal_id\":\"9\",\"contents\":[\"PROCESSO AS BUILT RENDICONTAZIONE\\r\\nDESCRIZIONE\\r\\nAS BUILT Totale\\r\\n80 100\\r\\nLa sezione AS BUILT Totale verrà mostrata \\ncome step finale.\\r\\nNel caso di Rendicontazione Parziali=SI verrà \\nmostrata dopo la milestone AS BUILT Parziale\\r\\nNel caso di Rendicontazione Parziale=NO verrà \\nmostrata dopo la milestone Walkin.\\r\\nGli approvatori tra Pacchetto Parziale e \\nPacchetto totale sono i medesimi.\\r\\nCome per il Parziale l’eventuale rifiuto del \\npacchetto Infratel dovrà essere verificato da \\nConcessione e nel caso di modifiche al \\npacchetto ingaggerà i service per le correzioni \\ntramite checklist ovvero Concessione deve \\nandare a sistema e nel caso Infratel abbia dato \\nKO deve dare KO su checklist ed inviare la \\ncheklist con i rilievi Infratel\\r\\n5.1 Produzione Pacchetto AB Totale FTTH Sevice Progettazione\\r\\n5.2 Validazione Pacchetto AB Tot. FTTH Serv. Controllo \\n5.4 Validazione Pacchetto AB Totale FTTH PMO\\r\\nService di Controllo\\r\\nPMO Creation\\r\\n5.5 Validazione Pacchetto AB Totale FTTH RUP e firme Regional Manager\\r\\n5.6 Validazione Pacchetto AB Totale FTTH Concessione Gruppo Concessione\\r\\n5.7 Invio Pacchetto AB Totale FTTH vs Infratel NEST\\r\\n5.8 Pacchetto AB Totale FTTH Validato da Infratel Gruppo concessione\\r\\n5.3 Validazione Pacchetto AB Totale FTTH FC Factory Construction\\r\\n5.9 Produzione Pacchetto AB Totale FWA Sevice Progettazione\\r\\n5.10 Validazione Pacchetto AB Tot. FWA Serv. Controllo \\n5.12 Validazione Pacchetto AB Totale FWA PMO\\r\\nService di Controllo\\r\\nPMO Creation\\r\\n5.13 Validazione Pacchetto AB Totale RUP e firme Regional Manager\\r\\n5. 14 Validazione Pacchetto AB Totale FWA Concessione Gruppo Concessione\\r\\n5.15 Invio Pacchetto AB Totale FWA vs Infratel NEST\\r\\n5.16 Pacchetto AB Totale FWA Validato da Infratel Gruppo concessione\\r\\n5.11 Validazione Pacchetto AB Totale FWA FC Factory Construction\"],\"score\":0.40117938278344795},{\"title\":\"Procedura operativa_Controlli\",\"drupal_id\":\"20\",\"contents\":[\"Per accedereallasezione dedicata al pacchettoAs-Builtoccorrerà andare sul progettorelativo alla componente“Municipality” (Step 3).\\n![image](http://eraamsnppya01.aws.openfiber.it:30101/files/ace6922b-75e8-4d68-bd7c-6f0d42ff833e/image-preview?timestamp=1751968451&nonce=1238c21ea1bfd1b4d3cf60bf60cf914e&sign=a7SsaP_5T3qKhr_4e7Bc9SmXC4Baf619zUlFzcrcPEU=)\\nAccesso al Tab “DocumentiAs-BuiltFTTH” e avvio controlli\\nDopo aver selezionato il Progetto, l’Utentepuò accedere al tab “DocumentiAs-BuiltFTTH” (Step 4) per avviare i controlli.\\nNella lista deiPlaceholderAs-Built, sono presenti idocumentiche si possono selezionare (Step 5)su cui effettuare i controllidi I livello (su singolodocumento) o di II livello(cross documenti).\\nSipuòselezionare un singolo documento ed in quel caso il sistemarestituiràsolo l’esito dei controlli di I livello su quel documento, oppure si possono selezionarepiùdocumenti.In questo caso senonci sonocontrolli incrociati, verranno fatti solo quelli di I livello, se invece hanno controlliincrociati saranno fatti anche quelli.\\nDopo aver spuntato i documenti di interesse, l’Utente può avviare i controlli selezionando il pulsante “Avvio Controlli” (Step 6).\\n![image](http://eraamsnppya01.aws.openfiber.it:30101/files/9cda37be-34f5-45b0-a320-9b16719801aa/image-preview?timestamp=1751968451&nonce=b0eeb7a92041f9f7572aaa257da016b6&sign=SiSa2h0jfAJM5UUSqng9UcikjEBo-XDdl8PD_t9-8GM=)\\nNel caso in cui l’utente non selezioni nessuno documento il sistemarestituiràun messaggio di errore come nell’immagine seguente:\\n![image](http://eraamsnppya01.aws.openfiber.it:30101/files/0b90e223-7520-4169-841f-e711eebf1ccb/image-preview?timestamp=1751968451&nonce=c7733b7a17af9d08d4617d2c0434e5e5&sign=tspAF0hLKBzQ-ooyJgYHjdpRZq9CHIRvYeSlf_02ohE=)\\nEsito Controlli\\nL’attivazione dell’Automation Platform consente di effettuare un subset di controlli sulla documentazione tecnica, i cui esiti vengono restituiti in tempi brevi.\\nL’esito sarà visualizzabile tramite pulsante “Esito Controlli”nellaseguente schermata:\\n![image](http://eraamsnppya01.aws.openfiber.it:30101/files/cd2f2ee0-0b41-4d4c-894b-0c6b46fd4384/image-preview?timestamp=1751968451&nonce=938e93ddd00f2d71c5642b65d5650300&sign=dmSpWs1nCSAlWGAgcQsXRSIRjFTGJAYVwH4rpm9hQ2Y=)\\nNella schermata di “Esito Controlli” (Step 7) sarà possibile visualizzare il numero di controlli con esito “OK” e“KO”.Nella barra in alto sono riportati in verde tutti quelli che hanno avuto esito positivo e in rosso quelli che hanno avuto esito negativo. Nel caso in cui almeno 1 controllo ha avuto esito negativo ilrundi controllo viene taggato e storicizzato come KO.\\nSotto alla barra con il resoconto dei controllièpossibile, aprendo la tendina, vedere tutti i controlli che sono andati in KO relativamente ai documenti selezionati in precedenza.In ogni casoèsempre possibile scaricare un report tramite apposito pulsante (Step 8), in cui saranno visualizzabili in formatoExceltutti i controlli effettuati, sia quelli che hanno dato esito negativo che positivo.\\nL’esito dei controlli nonèbloccante all’interno del flusso, pertanto se uno opiùcontrolli sono andati KO, l’utentepuòcomunque avanzare allo step successivo.\\nInoltre, nella sezione EsitoControlli,cliccandosulla lente accanto al nome del documento,è possibileaccedere aun cruscotto checonsentedivisualizzareivaloriestrattie diconfronto\"],\"score\":0.3999147372148075},{\"title\":\"Procedure operative - Produzione Automatica tramite Wizard e Caricamento a sistema\",\"drupal_id\":\"17\",\"contents\":[\"![image](http://eraamsnppya01.aws.openfiber.it:30101/files/48d73f29-a5cb-492d-9238-1b9ea43188be/image-preview?timestamp=1751968451&nonce=b5444768844eb4c3f51172855be34ce0&sign=wWUmFfV9L9uXXCqXwimaj-f7XWhq-Po2l1hV-3t4c44=)\\nNeST - Procedure Operative Documentazione Tecnica AS-BuiltFTTH\\nProduzioneAutomaticatramite Wizard e Caricamentoa sistema\\n| Redatto da: | xxx | <inserire funzione/direzione> es. Acquisti e Servizi, NO A&B,… | 16/06/2025 |\\n| --- | --- | --- | --- |\\n| Approvato da: | <inserire riferimento> | <inserire funzione/direzione> es. Acquisti e Servizi, NO A&B,… | xx/xx/2025 |\\nThis document contains proprietary information of Open Fiber and should only be used by the recipient in relation to the purposes for which it was received.All forms of reproduction or dissemination without the express consent of Open Fiber are forbidden.\\nCronologia delle versioni\\n| Versione | Data | Descrizione / Nome File |\\n| --- | --- | --- |\\n| 1.0 | 16/06/2025 | Prima versione del documento |\\n| | | |\\nObiettivi\\nQuesto documento ha lo scopo di illustrare le procedure operativerelative alle attività di caricamento su Nest dei deliverable diAs built FTTH a carico del Service di progettazione.In particolare,verrà descritto come produrre in automatico i documenti generabili dal Wizard di Nest e come caricare quelli prodotti tramite altri sistemi operazionali.\\nAmbito di applicazione\\nLa procedura disciplinai flussi operatividi Open Fiberutili a fornire la documentazione tecnicanecessariaadInfratel nell’ambito delle attività di Rendicontazione.Il pacchetto tecnicoAs-Built FTTHè composto da una serie didocumenti, variabili da 15 a 20 a seconda della tipologia del comune,che devono essere caricati e/oprodotti su NeST.\\nAccesso al sistema\\nL’utente“Service di progettazione”potrà effettuare l’accesso al sistema NeSTtramite il seguente link:\\nUna volta inserito l’username e la password correttamente si può cliccare su ‘Accedi’\\n![image](http://eraamsnppya01.aws.openfiber.it:30101/files/61cde0fd-1e54-48a7-a6f9-19ea0c8a46d4/image-preview?timestamp=1751968451&nonce=5e1a8310cc3194b2d77c4b23616c826e&sign=GOI7fJrvlwuAWdIHP3tvsF54JVb_kMdR5U_ODY4D92M=)\\nAccesso al Tab “Documenti As-Built”\\nUna voltaeffettuato l’accesso nella schermata iniziale,si dovrà inserire nella barra di ricerca il nome del Comune su cui il Service di Progettazione dovrà produrre/caricarei documenti facendo così apparire una serie di suggerimenti.\\nPassando con il mouse sul comune interessato (Step 1) e poi sulla lista relazionata ‘Projects’ (Step 2), saranno mostrati tutti i Progetti dipendenti con l’oggetto che è stato selezionato\"],\"score\":0.39495796408888717}]}"
                          }
                      ]
                  }
              },
              "lastBubbleBlockId": "txsswo9yz1p6nulork9sta9g",
              "expectsDedicatedReply": true
          }
      ],
      "logs": []
  }

  export const mockedhistoryArray = [
        {
            "chat_id": "1769762107604",
            "summary": "Gestione rendicontazione",
            "current_session_id": "zhqfsxn6hg5y2vniqpspk6sp"
        },
        {
            "chat_id": "1769183416302",
            "summary": "Rendicontare tecnica AG",
            "current_session_id": "rux418wzfja5i38b29ur4t2b"
        },
        {
            "chat_id": "1769183998618",
            "summary": "Saluto ciao",
            "current_session_id": "jeoedvegdcdc5v9y8s3smhfk"
        },
        {
            "chat_id": "1767792820493",
            "summary": "Saluto conversazione",
            "current_session_id": "dn34azvz33iwysc77uzw92vf"
        },
        {
            "chat_id": "1769184962671",
            "summary": "Saluto amichevole",
            "current_session_id": "zwx218ghm0yvj6s0ievxe8hg"
        },
        {
            "chat_id": "1769184988340",
            "summary": "Saluto ciao",
            "current_session_id": "sbm67ri9lv6xn7wea060ltiy"
        },
        {
            "chat_id": "1769184995540",
            "summary": "Saluto utente",
            "current_session_id": "lcpppvef1vyudmset2ums2bo"
        },
        {
            "chat_id": "1769185097521",
            "summary": "Saluto iniziale",
            "current_session_id": "utfpdx05zwop3ogsvl7iby9m"
        },
        {
            "chat_id": "1769185088634",
            "summary": "Gestione rendicontazione",
            "current_session_id": "exvdejc3bn6nu5mdyxkwarwi"
        },
        {
            "chat_id": "1769187252462",
            "summary": "Saluto ciao",
            "current_session_id": "rqt40r2xpgwhhd57qq79nywf"
        },
        {
            "chat_id": "1769187280370",
            "summary": "Informazioni rendicontazione",
            "current_session_id": "x5ilif2c8gxme0ppall27ove"
        },
        {
            "chat_id": "1769187372226",
            "summary": "Saluto ciao",
            "current_session_id": "c97fehdt6bls6t17k0ilo0wm"
        },
        {
            "chat_id": "1769187395415",
            "summary": "Saluto amicizie",
            "current_session_id": "e8xc0h5z48akr210d8csz7xe"
        },
        {
            "chat_id": "1769187437222",
            "summary": "Rendicontazione tecnica AG",
            "current_session_id": "whyn0ye5x5xd2jdymyliqbxz"
        },
        {
            "chat_id": "1769510726847",
            "summary": "Saluto amichevole",
            "current_session_id": "wthcsv398w7ggsrn89aow58v"
        },
        {
            "chat_id": "1769521280939",
            "summary": "Rendicontazione tecnica AG",
            "current_session_id": "fuykd5loilbe86cz7z64e8qa"
        },
        {
            "chat_id": "1769521280939",
            "summary": "Rendicontazione tecnica AG",
            "current_session_id": "lpcv0q4z48d7am1d28n1ouwu"
        },
        {
            "chat_id": "1769525459658",
            "summary": "Offerta di aiuto all\u0027admin",
            "current_session_id": "ssvt0rgnmvq06clauvfyu88a"
        },
        {
            "chat_id": "1769525599729",
            "summary": "Gestione rendicontazione",
            "current_session_id": "i4o42sew4qitdhezfp0q1i67"
        },
        {
            "chat_id": "1769529298767",
            "summary": "Saluto amichevole",
            "current_session_id": "n611u9vlwxpxi45omlschces"
        },
        {
            "chat_id": "1769529316878",
            "summary": "Saluto amichevole",
            "current_session_id": "dhdxnshlg2fzij19to9bt0ez"
        },
        {
            "chat_id": "1769616047526",
            "summary": "Gestione rendicontazione",
            "current_session_id": "wa84bdpslastcrfsy7edryrb"
        },
        {
            "chat_id": "1769679529526",
            "summary": "Saluto amichevole",
            "current_session_id": "rsmbpsocuiwukmp8f6k6qn1e"
        },
        {
            "chat_id": "1769679616860",
            "summary": "Saluto conversazione",
            "current_session_id": "k25i6dcwn6kcex8kewhvxki3"
        },
        {
            "chat_id": "1769694412483",
            "summary": "Saluto iniziale",
            "current_session_id": "cc5prv89pmippblmkm40ecsr"
        },
        {
            "chat_id": "1769783461590",
            "summary": "Gestione rendicontazione",
            "current_session_id": "bgjyekpvqgvauy3n60pq4cvz"
        }
    ]
